import { ReportsRepo } from '../../reports/reports.repo';
import { ReportingService } from '../../common/reporting.service';
import * as _ from 'lodash'
import * as moment from 'moment'
import { EmailStatus } from './models/emailStatus';
import { AuthService } from '../../common/auth.service';
import { Roles } from '../../common/enums/Roles'
import { contactus } from '../../contactus/contactus';

class PortfolioManagementReportController implements ng.IOnInit {
  public clientId: number;
  public selectedPortfolioIds: any
  public selectedCurrency: any
  public clientPortfolios: any
  public clientNumber: any

  public isLoading: Boolean = false;

  public reportTypes: any;
  public reports: any = {};

  /** @ngInject */
  constructor(private $scope: angular.IScope, private notifyjs: any, private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService, private reportsRepo: ReportsRepo, private reportingService: ReportingService,
    private authService: AuthService) { }

  $onInit() {
    this.getClientReports();
  }


  generateReport = () => {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.selectedPortfolios = this.selectedPortfolioIds;
    tempScope.selectedCurrency = this.selectedCurrency;
    tempScope.clientNumber = this.clientNumber;
    tempScope.clientPortfolios = this.clientPortfolios.map((portfolio) => portfolio.id)
    tempScope.lockedDates = _.map(_.flatMap(this.reports, (r) => _.filter(r, t => t.isLocked)) as any[], r => r.date)
    this.$mdDialog.show({
      template: `<generate-report-dialog selected-portfolios="selectedPortfolios" selected-currency="selectedCurrency" restricted-dates="lockedDates" client-number="clientNumber" client-portfolios="clientPortfolios"></generate-report-dialog>`,
      clickOutsideToClose: true,
      scope: tempScope
    })
      .then((result => {
        if (result) {
          this.getClientReports();
        }
      }))
  }


  getClientReports = () => {
    this.getReportTypes()
      .then(() => {
        _.forEach(this.reportTypes, (reportType) => {
          // at first just fetch the reports for the first client
          this.getReportsForReportType(this.clientNumber, reportType);
        });

      });

  }

  private getReportTypes() {
    this.isLoading = true;
    return this.reportsRepo.getReportTypes()
      .then((res) => {
        if (res && res.data) {
          let array = res.data as Array<any>;
          let filteredArray = array.filter(item => item.name !== "PortfolioAttribution");
          this.reportTypes = _.map(filteredArray, (reportType) => { return reportType.name });
        }
      })
      .catch(() => {
        this.notifyjs("The reports could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
      .finally(() => this.isLoading = false);
  }

  private getReportsForReportType(clientNumber, reportType) {
    this.isLoading = true
    return this.reportsRepo.getClientReportByType(clientNumber, reportType)
      .then((reportDetails) => {
        this.reports[reportType] = [];

        _.forEach(reportDetails, (report) => {
          const displayDate = moment(report.reportDate).format('MMMM Y');
          let currentReport = _.find(this.reports[reportType], (r) => r['date'] == displayDate);

          if (!currentReport) {
            currentReport = {
              date: displayDate,
              type: reportType,
              isLocked: report.isLocked,
              isReconciled: report.isReconciled,
              reports: [],
              custodianReports : report.custodianReports
            }
            this.reports[reportType].push(currentReport);
          }

          const reportDetails = {reportId: report.reportId,
            bucket: report.bucketName,
            reportName: '',
            key: report.reportKey,
            emailStatuses: report.emailStatuses,
          };

          if (report.externalSource === null) {
            reportDetails.reportName = `Confident (${report.reportCurrency})`;
          } else if (report.externalSource === 'MCB') {
            reportDetails.reportName = 'MCB';
          } else if (report.externalSource === 'Rothschild') {
            reportDetails.reportName = 'EDR';
          }

          currentReport.reports.push(reportDetails);
        });
      })
      .catch((err) => this.notifyjs("The reports could not be loaded. Please try again later or contact the System Administrator.", "error"))
      .finally(() => this.isLoading = false);
  }

  public getDownloadCountOutput(report: any) {
    let keys = Object.keys(report.reports);
    let count = keys.length;
    if (count === 1)
      return "1 report";
    else
      return `${count} reports`;
  }

  public formatToStartCase(word) {
    return _.startCase(word);
  }

  public openReport(reportDetails: any) {
    this.reportingService.openReport(reportDetails.key);
  }

  public isSending(reportDetails): boolean {
    if (!reportDetails) {
      return true;
    }

    return reportDetails.emailStatuses.some(s => s.status === EmailStatus.SENDING)
  }

  public toggleReportLock(reportDetails) {
    const userRoles = this.authService.getUserRoles();
    if (!reportDetails.isLocked && (userRoles.indexOf(Roles.SeniorManagement) === -1 && userRoles.indexOf(Roles.SystemAdministrator) === -1)) {
      reportDetails.isLocked = true;
      this.notifyjs('Only senior management can unlock a report.', 'warning');
      return;
    }

    const reportIds = _.map(reportDetails.reports, (r) => r.reportId);
    this.reportsRepo.toggleReportLock(reportIds, reportDetails.isLocked);
  }

  private displayStatus(status: EmailStatus) {
    switch (status) {
      case EmailStatus.PENDING:
        return 'Not Sent';
      case EmailStatus.SENDING:
        return 'Busy';
      case EmailStatus.OPENED:
        return 'Opened';
      case EmailStatus.FAILED:
        return 'Failed To Send';
      case EmailStatus.SENT:
      default:
        return 'Sent';
    }
  }
  public emailStatusTooltip(reportDetails) {
    return reportDetails.emailStatuses.reduce((prev, curr) => prev += `${curr.emailAddress} - ${this.displayStatus(curr.status)}\r\n`, '')
  }

  public emailReport(reportDetails: any) {
    if (reportDetails.emailStatuses.every(s => s.status === EmailStatus.PENDING)) {
      this.reportsRepo.sendReportEmails(reportDetails.reportId)
        .then(() => reportDetails.emailStatuses.forEach(s => s.status = EmailStatus.SENDING))
        .catch(err => this.notifyjs(err.data));
    } else if (reportDetails.emailStatuses.some(s => s.status === EmailStatus.SENDING)) {
      return;
    } else if (reportDetails.emailStatuses.every(s => s.status === EmailStatus.SENT || s.status === EmailStatus.FAILED || s.status === EmailStatus.OPENED)) {
      const dialogScope = this.$scope.$new() as any;
      dialogScope.emails = reportDetails.emailStatuses;

      this.$mdDialog.show({
        template: '<md-dialog><email-select-dialog available-emails="emails"></email-select-dialog></md-dialog>',
        scope: dialogScope,
      })
        .then((emailIds) =>
          this.reportsRepo.sendReportEmailToSpecificClients(reportDetails.reportId, emailIds)
            .catch(err => this.notifyjs(err))
        )
        .then(() => reportDetails.emailStatuses.forEach(s => s.status = EmailStatus.SENDING))
        .catch(err => console.log('Cancelled'));
    }
  }


  uploadCustodianReport = (report) => {
    const tempScope = this.$rootScope.$new(true) as any;

    tempScope.clientPortfolios = this.clientPortfolios.map((portfolio) => {
      return {
        id: portfolio.id,
        name: portfolio.name
      }
    });

    tempScope.reportDate = report.date

    this.$mdDialog.show({
      template: `<custodian-report-dialog client-portfolios="clientPortfolios" report-date="reportDate"> </custodian-report-dialog>`,
      clickOutsideToClose: true,
      scope: tempScope
    })
    .then(res => {
      if(res){
        this.getClientReports();
      }
    })

  }


  deleteCustodianReport = (custodianReport) => {
    this.isLoading = true
    this.reportsRepo.deleteCustodianReport(custodianReport.reportId)
    .then(res => {})
    .catch(err => {
      this.notifyjs("Failed to delete custodian report " + err.data )
    })
    .finally(() => {
      this.isLoading = false
      this.getClientReports()
    })
  }

  deleteClientReport = (clientReport) => {
    this.isLoading = true
    this.reportsRepo.deleteClientReport(clientReport.reportId)
    .then(res => {})
    .catch(err => {
      this.notifyjs("Failed to delete custodian report " + err.data )
    })
    .finally(() => {
      this.isLoading = false
      this.getClientReports()
    })
  }

}

export const portfolioManagementReport: angular.IComponentOptions = {
  template: require('./portfolioadmin.reports.html'),
  controller: PortfolioManagementReportController,
  bindings: {
    clientId: "<",
    selectedPortfolioIds: "<",
    selectedCurrency: "<",
    clientPortfolios: "<",
    clientNumber: "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/reportManagement/portfolioadmin.reports.ts